import baseUrl from '../../../utils/baseUrl';
import getToken from '../../../utils/getToken';

interface AddFootprintRequest {
  footprintableType: string;
  footprintableId?: string;
  userProfileId?: string;
  artistId?: string;
  memberIds?: string[];
  contentType?: string;
  linkUrl?: string;
  // eventId 추가하기
  description?: string;
  dataUrls?: string[];
  eventId?: string;
  name?: string;
  kakaoUID?: string;
  siteType?: string;
}

export default async function AddFootprint(request: AddFootprintRequest) {
  return fetch(`${baseUrl()}/api/v1/footprints`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${getToken()}`
    },
    body: JSON.stringify({
      location: {
        name: request.name,
        kakao_uid: request.kakaoUID,
        site_type: request.siteType
      },
      footprint: {
        footprintable_type: request.footprintableType,
        ...(request.footprintableId ? { footprintable_id: request.footprintableId } : {}),
        category: request.siteType,
        artist_id: request.artistId,
        member_ids: request.memberIds,
        user_profile_id: request.userProfileId,
        description: request.description,
        link_url: request.linkUrl,
        data_urls: request.dataUrls,
        event_id: request.eventId,
        content_type: request.contentType
      }
    })
  });
}
